import React, { useContext, useEffect, useMemo, useReducer } from 'react'
import { actions } from '../actions/business';
import { CONFIG } from '../config';

const initialState = {
    business: window.localStorage.getItem(CONFIG.storage.business) ? window.localStorage.getItem(CONFIG.storage.business) : null,
    loading: false
}

const BusinessContext = React.createContext({
    state: null,
    dispatch: null,
});

function reducer(state, action) {
    switch (action.type) {
        case actions.FETCH:
            return { ...state, business: action.payload }
        case actions.LOADING:
            return { ...state, loading: action.payload }
        default:
            return state;
    }
}

export default function BusinessProvider({ children }) {

    const [state, dispatch] = useReducer(reducer, initialState);
    const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

    useEffect(() => {        
        window.localStorage.setItem(CONFIG.storage.business, state.business);
    }, [state]);

    return <BusinessContext.Provider value={contextValue}>
        {children}
    </BusinessContext.Provider>
}

export const useBusinessProvider = () => useContext(BusinessContext);